import React from 'react';

export default function Tracking() {
  return (
    <div>
      <div className="order-details-container row">
        <section className="order-details">
          <div className="tracking-container mb-3">
            {/* Step 1: Order Pending */}
            <div className="tracking-step completed">
              <div className="step-info">
                <p className="step-title">09:00</p>
                <p className="step-date">Tue, June 25</p>
              </div>
              <div className="step-icon">
                <span className="checkmark">✓</span>
              </div>
              <div className="step-info">
                <p className="step-title">Order Pending</p>
                <p className="step-date">We have received your order</p>
              </div>
            </div>

            {/* Step 2: Order Processing */}
            <div className="tracking-step completed">
              <div className="step-info">
                <p className="step-title">09:00</p>
                <p className="step-date">Tue, June 25</p>
              </div>
              <div className="step-icon">
                <span className="checkmark">✓</span>
              </div>
              <div className="step-info">
                <p className="step-title">Order Processing</p>
                <p className="step-date">Awaiting confirmations...</p>
              </div>
            </div>

            {/* Step 3: Order Delivered */}
            <div className="tracking-step completed">
              <div className="step-info">
                <p className="step-title">09:00</p>
                <p className="step-date">Tue, June 26</p>
              </div>
              <div className="step-icon">
                <span className="checkmark">✓</span>
              </div>
              <div className="step-info">
                <p className="step-title">Order Delivered</p>
                <p className="step-date">Order #1234 from Kidskart</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
